export default __webpack_public_path__ + "static/soehne-web-kraftig-c1c468817dcd2bf2d38ac2ae49273e70.woff2";